import React, { useEffect } from "react";
import Routers from "./routes/routing.jsx";
import Amplify from "aws-amplify";
import awsExports from "./aws-exports";
import { API, graphqlOperation } from "aws-amplify";
import {
	listProductTables,
	productById,
	listUserInfos,
	byUserId,
} from "./graphql/queries";
import { useDispatch, useSelector } from "react-redux";
import {
	campaignData,
	tpriceData,
	draftId,
	productData,
	langData,
	login,
} from "./store/action";

Amplify.configure(awsExports);

function App() {
	const dispatch = useDispatch();
	const lang = useSelector((state) => state.language.lang);
	const product = useSelector((state) => state.product);
	const logindata = useSelector((state) => state.login);
	const getId = localStorage.getItem("email");
	const getProducts = async (getId) => {
		let nextToken = null;
		try {
			const productImages = await API.graphql(
				graphqlOperation(productById, {
					id: getId,
					nextToken,
					limit: 100,
				}),
			);
			dispatch(
				campaignData({
					campaign: productImages.data.productById,
				}),
			);
		} catch (error) {
			return error;
		}
	};

	useEffect(() => {
		getProducts(getId);
		dispatch(
			tpriceData({
				tprice: 0,
			}),
		);
	}, []);

	const getUser = async (getId) => {
		try {
			let users;
			let nextTokens;
			do {
				users = await API.graphql(
					graphqlOperation(byUserId, {
						userId: getId,
						nextTokens,
						limit: 500,
					}),
				);
				nextTokens = users.data.byUserId.nextToken;
			} while (nextTokens);
			if (users) {
				dispatch(
					login({
						WebflowCustomerId: users.data.byUserId.items[0].WebflowCustomerId,
					}),
				);
			}
		} catch (error) {
			return error;
		}
	};

	useEffect(async () => {
		if (logindata.loginStatus && !logindata.WebflowCustomerId) {
			getUser(logindata.userDetail);
		}
	}, [logindata.loginStatus]);

	window.addEventListener("unload", function (event) {
		dispatch(
			draftId({
				draftProductId: "",
			}),
		);
		dispatch(
			productData({
				id: "",
				step: 0,
				shirt: {},
				designnimg: "",
				color: "",
				realprice: 0,
				price: 0,
				day: 0,
				sales: 0,
				shirtname: "",
				brief: "",
				detail: "",
				campaign: 0,
				shirtdesign: [],
				shirtdesignback: [],
				frontDesignObj: null,
				backDesignObj: null,
				alterImage: null,
				edit: false,
				hello: {},
				seldata: false,
				shirtsdata1: "",
				shirtsdata2: "",
				designnimgback: "",
			}),
		);
	});

	useEffect(() => {
		if (lang === "FR") {
			dispatch(
				langData({
					lang: "EN",
				}),
			);
		}
	}, []);

	useEffect(() => {
		if (product.seldata === true) {
			dispatch(
				productData({
					shirt: {
						...product.shirt,
						frontImg: product.shirtsdata1,
						backImg: product.shirtsdata2,
						category: product.hello.category,
						cost: product.hello.cost
							? product.hello.cost
							: product.hello.realprice,
						garmentDescription: product.hello.garmentDescription,
						garmentName: product.hello.garmentName,
						id: product.hello.id,
						color: product.hello.color,
					},
					target: product.hello.target ? product.hello.target : 5,
					color: product.hello.shirtColor ? product.hello.shirtColor : "",
					brief: product.hello.brief ? product.hello.brief : "",
					day: product.hello.days ? product.hello.days : 0,
					campaign: product.hello.noOfCampaigns
						? product.hello.noOfCampaigns
						: 0,
					detail: product.hello.detail ? product.hello.detail : "",
					price: product.hello.sellingPrice ? product.hello.sellingPrice : 0,
					sales: product.hello.target ? product.hello.target : 0,
					shirtname: product.hello.shirtName ? product.hello.shirtName : "",
					shirtdesign: [],
					shirtdesignback: [],
					id: product.hello.id && product.hello.id,
					frontDesignObj: product.hello?.frontDesign
						? {
								width: product.hello.frontDesign.width,
								height: product.hello.frontDesign.height,
								x: product.hello.frontDesign.x,
								y: product.hello.frontDesign.y,
						  }
						: null,
					backDesignObj: product.hello?.backDesign
						? {
								width: product.hello.backDesign.width,
								height: product.hello.backDesign.height,
								x: product.hello.backDesign.x,
								y: product.hello.backDesign.y,
						  }
						: null,
				}),
			);
			dispatch(
				productData({
					seldata: false,
				}),
			);
		}
	}, [product.shirtsdata1 && product.shirtsdata2]);

	return (
		<>
			<Routers />
		</>
	);
}

export default App;
